
import { Component, Vue, Watch } from "vue-property-decorator";
import {
  apiShopDetail,
  apiShopAdd,
  apiShopEdit,
  apiSetMealLists,
  apiGetExConfig,
} from "@/api/shop";
import historyMeal from "./components/history-meal.vue";
import { debounce } from "@/utils/util";
import lsPagination from "@/components/ls-pagination.vue";
import ExportData from "@/components/export-data/index.vue";
import LsDialog from "@/components/ls-dialog.vue";
import MaterialSelect from "@/components/material-select/index.vue";
@Component({
  components: {
    MaterialSelect,
    historyMeal,
  },
})
export default class ListsDetail extends Vue {
  /** S Data **/

  identity: number | null = null; // 当前编辑用户的身份ID

  setMealData: any = [];

  // 添加商城表单数据
  form: any = {
    name: "", // 名称
    english_name: "",
    log1: "",
    ai_name: "", // ai名称
    super_admin: "", // 账号
    super_password: "", // 密码
    super_password_confirm: "", // 确认密码
    status: 1, // 商城状态 0-停止服务 1-开启服务
    contact: "", // 联系人
    contact_mobile: "", // 联系人手机号
    domain_alias_list: [""], // 域名别名列表
    is_check_domain: 0, // 是否验证域名
    shop_url: "", // 当前域名
    set_meal_id: "", // 套餐ID
    expires_time: "", // 到期时间
    remark: "", // 备注
    click_number: "", // 初始点击量
    day_number: "", // 控制初始天数
    admin_money: "", // 金额
    money_number: "", // 每日点击有效次数
    virtual_views_range: "", // 虚拟浏览量区间
    virtual_sales_range: "", // 虚拟销售量区间
    shop_data: {},
    is_shop: 1, //店铺菜单：0=关闭 1=开启',
    is_goods: 1, //商品菜单：0=关闭 1=开启',
    is_order: 1, //'订单菜单：0=关闭 1=开启',
    is_user: 1, //用户菜单：0=关闭 1=开启',
    is_marketing: 1, //营销菜单：0=关闭 1=开启
    is_application: 1, //应用菜单：0=关闭 1=开启
    is_finance: 1, //财务菜单：0=关闭 1=开启
    is_data: 1, //数据菜单：0=关闭 1=开启
    is_channel: 1, //渠道菜单：0=关闭 1=开启
    is_setting: 1, //设置菜单：0=关闭 1=开启
    is_gather: 1, //商品采集按钮：0=关闭 1=开启',
    total_order_amount: 0,
    order_num: 0,
    visitor_count: 0,
    new_user_count: 0,
    ex: {}, // 初始化为空对象，避免访问属性时出错
    exConfig: [], // 新增 exConfig 属性，用于存储后台返回的配置
    click_number_range: "", //初始点击量区间
    total_order_amount_range: "", //营业额点击量区间
    order_num_range: "", //成交单数区间
    new_user_count_range: "", //访客数区间
  };

  // 表单校验
  rules = {
    name: [{ required: true, message: "请输入商城名称", trigger: "blur" }],
    super_admin: [
      { required: true, message: "请输入商城名称", trigger: "blur" },
    ],
    super_password: [
      { required: true, message: "请输入密码", trigger: "blur" },
      {
        validator: (rule: object, value: string, callback: any) => {
          !value ? callback(new Error("请输入密码")) : callback();
        },
        trigger: "blur",
      },
    ],
    super_password_confirm: [
      { required: true, message: "请再次输入密码", trigger: "blur" },
      {
        validator: (rule: object, value: string, callback: any) => {
          if (this.form.password) {
            if (!value) callback(new Error("请再次输入密码"));
            if (value !== this.form.password) {
              callback(new Error("两次输入密码不一致!"));
            }
          }
          callback();
        },
        trigger: "blur",
      },
    ],
    set_meal_id: [
      { required: true, message: "请选择套餐", trigger: ["blur", "change"] },
    ],
    expires_time: [
      {
        required: true,
        message: "请选择到期时间",
        trigger: ["blur", "change"],
      },
    ],
  };

  /** E Data **/

  /** S Methods **/
  // 一键开启或关闭所有菜单
  toggleAllMenus(status: number) {
    this.form.is_shop = status;
    this.form.is_goods = status;
    this.form.is_order = status;
    this.form.is_user = status;
    this.form.is_marketing = status;
    this.form.is_application = status;
    this.form.is_finance = status;
    this.form.is_data = status;
    this.form.is_channel = status;
    this.form.is_setting = status;
    this.form.is_gather = status;
  }

  // 点击表单提交
  onSubmit(formName: string) {
    // 验证表单格式是否正确
    const refs = this.$refs[formName] as HTMLFormElement;
    refs.validate((valid: boolean): any => {
      if (!valid) return;

      // 将 exConfig 中的 key 作为 ex 对象的字段名称
      this.form.exConfig.forEach((item: any) => {
        this.form.ex[item.key] = item.value;
      });

      // 将ex转换为JSON字符串
      this.form.ex = JSON.stringify(this.form.ex);

      // 将域名别名列表拼接成字符串
      this.form.domain_alias = this.form.domain_alias_list.join(",");

      // 处理点击量区间值
      // if (this.form.click_number_min && this.form.click_number_max) {
      //   this.form.click_number_range = `${this.form.click_number_min}-${this.form.click_number_max}`;
      // }

      // 处理营业额点击量区间值
      // if (this.form.total_order_amount_min && this.form.total_order_amount_max) {
      //   this.form.total_order_amount_range = `${this.form.total_order_amount_min}-${this.form.total_order_amount_max}`;
      // }

      // 处理成交单数区间值
      // if (this.form.order_num_min && this.form.order_num_max) {
      //   this.form.order_num_range = `${this.form.order_num_min}-${this.form.order_num_max}`;
      // }

      // 订单增长区间
      if (this.form.order_growth_min && this.form.order_growth_max) {
        this.form.order_growth = `${this.form.order_growth_min}-${this.form.order_growth_max}`;
      }

      // 处理虚拟浏览量和虚拟销售量的区间值
      if (this.form.virtual_views_min && this.form.virtual_views_max) {
        this.form.virtual_views_range = `${this.form.virtual_views_min}-${this.form.virtual_views_max}`;
      }
      if (this.form.virtual_sales_min && this.form.virtual_sales_max) {
        this.form.virtual_sales_range = `${this.form.virtual_sales_min}-${this.form.virtual_sales_max}`;
      }

      if (!this.identity) {
        this.handleShopAdd();
      } else {
        this.handleShopEdit();
      }
    });
  }

  // 添加域名输入框
  addDomain() {
    this.form.domain_alias_list.push("");
  }

  // 移除域名输入框
  removeDomain(index: number) {
    if (this.form.domain_alias_list.length > 1) {
      this.form.domain_alias_list.splice(index, 1);
    }
  }

  // 添加商城
  async handleShopAdd(): Promise<void> {
    await apiShopAdd({ ...this.form });
    setTimeout(() => this.$router.go(-1), 500);
  }

  // 编辑商城
  async handleShopEdit(): Promise<void> {
    await apiShopEdit({ ...this.form, id: this.identity });
    setTimeout(() => this.$router.go(-1), 500);
  }

  // 获取详情
  async getShopDetailFunc(): Promise<void> {
    const res: any = await apiShopDetail({
      id: this.identity as number,
    });
    // 将 domain_alias 字符串转换为数组
    if (res.domain_alias) {
      res.domain_alias_list = res.domain_alias.split(",");
    }
    // 处理虚拟浏览量和虚拟销售量的区间值回显
    if (res.virtual_views_range) {
      const [minViews, maxViews] = res.virtual_views_range.split("-");
      res.virtual_views_min = parseInt(minViews);
      res.virtual_views_max = parseInt(maxViews);
    }
    if (res.virtual_sales_range) {
      const [minSales, maxSales] = res.virtual_sales_range.split("-");
      res.virtual_sales_min = parseInt(minSales);
      res.virtual_sales_max = parseInt(maxSales);
    }
    // 回显 exConfig 数据
    if (res.ex) {
      this.form.ex = res.ex;
    }
    // 将 exConfig 数据回显到表单中
    if (res.exConfig && Array.isArray(res.exConfig)) {
      this.form.exConfig = res.exConfig.map((item: any) => {
        // 如果 ex 中有对应的数据，则使用 ex 中的数据作为默认值
        if (res.ex && res.ex[item.key]) {
          return {
            ...item,
            value: res.ex[item.key],
          };
        }
        return item;
      });
    } else {
      // 如果 res.exConfig 不存在，则从接口获取 exConfig 数据
      const exConfigRes: any = await apiGetExConfig();
      this.form.exConfig = exConfigRes.map((item: any) => {
        if (res.ex && res.ex[item.key]) {
          return {
            ...item,
            value: res.ex[item.key],
          };
        }
        return {
          ...item,
          value: item.options[0].value, // 默认选择第一个选项
        };
      });
    }
    Object.keys(res).map((key) => {
      this.$set(this.form, key, res[key]);
    });
  }

  // 获取套餐列表
  async getSetMealLists(): Promise<void> {
    const { lists } = await apiSetMealLists({ status: 1 });
    this.setMealData = lists;
  }

  // 获取 ex 配置
  async getExConfig(): Promise<void> {
    const res: any = await apiGetExConfig();
    // 为每个配置项设置默认值
    this.form.exConfig = res.map((item: any) => {
      return {
        ...item,
        value: item.options[0].value, // 默认选择第一个选项
      };
    });
  }

  /** E Methods **/

  /** S Life Cycle **/
  created() {
    const query: any = this.$route.query;

    // 编辑模式：初始化数据
    this.identity = +query.id;
    if (+query.id) {
      this.getShopDetailFunc();
    }

    this.onSubmit = debounce(this.onSubmit, 2000);
    this.getSetMealLists();
    this.getExConfig(); // 从数据配置中获取 exConfig
  }
  /** E Life Cycle **/
}
